
        Component.define('section-works', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el             = $(el);
const $slider         = $el.find('.slider-works');

$slider.slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 400,
    dots: true,
    prevArrow: '<button type="button" class="slick-arrow slick-prev" aria-label="Anterior"><svg><use xlink:href="#svg-arrow-simple" xlink:title="Anterior" /></svg></button>',
    nextArrow: '<button type="button" class="slick-arrow slick-next" aria-label="Próximo"><svg><use xlink:href="#svg-arrow-simple" xlink:title="Próximo" /></svg></button>'
});

        });